import React, { useContext, useState } from "react";
import PrimaryHeading from "../../../utils/PrimaryHeading/PrimaryHeading";
import { FAQuestions } from "../../../Mock/Learn";
import { IoIosArrowDown } from "react-icons/io";
import clsx from "clsx";
import Timer from "../../../main/Timer/Timer";
import { motion } from "framer-motion";
import PrimaryBtn from "../../../utils/PrimaryBtn/PrimaryBtn";
import { MyContext } from "../../../pages/Funnel";

const FAQ = () => {
  const { state } = useContext(MyContext);
  return (
    <section className="max-w-7xl m-auto my-16 bg-white py-12 px-5 rounded-xl">
      <div className="flex justify-center mb-12">
        <PrimaryHeading>Frequently Asked Questions</PrimaryHeading>
      </div>
      <div className="space-y-4">
        {FAQuestions.map((val, index) => (
          <Child {...val} key={index} index={index} />
        ))}
      </div>
      <div className="mt-10 flex flex-col items-center justify-center">
        <Timer />
        <PrimaryBtn>Begin Your Course</PrimaryBtn>
      </div>
    </section>
  );
};

export default FAQ;

const Child = ({ title, points, index }) => {
  const [state, setState] = useState(false);
  const { state:details } = useContext(MyContext);
  return (
    <div
      style={{ border: `1px solid ${details.color}` }}
      className="border  border-primary rounded-md overflow-hidden  p-5 cursor-pointer max-sm:3"
      onClick={() => setState(!state)}>
      <div className={clsx("      ")}>
        <div className="flex justify-between items-center">
          {" "}
          <p
            style={{ color: details.color }}
            className="text-base flex gap-1 text-primary font-medium ">
            {" "}
            <span>{index + 1}. </span> {title}{" "}
          </p>
          <div
            style={{ color: details.color }}
            className="text-2xl text-primary">
            <IoIosArrowDown
              className={clsx(
                state ? "rotate-180" : "",
                "transition-all duration-300"
              )}
            />
          </div>
        </div>
      </div>
      <motion.div
        transition={{ duration: 0.3 }}
        animate={{ height: state ? "auto" : "0px", overflow: "hidden" }}>
        <p className="px-5 pt-4 max-w-3xl text-sm font-medium">{points}</p>
      </motion.div>
    </div>
  );
};
